import React, { Component } from 'react'
import PropTypes from 'prop-types'

// import SimpleHeader from '../SimpleHeader'

// Utils
import { translation } from '../../../../utils/helpers'
import { renderFullDate } from '../../../../utils/time'

// Elements
import Panel from '../../../elements/panel'
import { ReferenceIcons } from '../../../elements/icons'
import Inline from '../../../elements/inline'
import PanelHeader from '../../../elements/panelHeader'

class ReferenceOrderData extends Component {
  renderLabel (dictionaryKey, label) {
    return (
      <Inline fillChildNum={[0, 1]} block>
        <span>{translation(dictionaryKey)}:</span>
        <span>{label}</span>
      </Inline>
    )
  }

  render () {
    const { referenceInfo, department, isApproval } = this.props

    const isPaint = department === 0

    const icon = isPaint ? ReferenceIcons.Info : null

    return (
      <Panel title={translation('14918')} icon={icon}>
        {/* <SimpleHeader title={translation('14918')} src='images/svgs/referal/Car-info-VS.svg' /> */}
        {this.renderLabel('294', referenceInfo.OrderInfo.Orderid)}
        {this.renderLabel('78', referenceInfo.OrderInfo.RegNumber)}
        {this.renderLabel('145', translation(referenceInfo.OrderInfo.Brand))}
        {this.renderLabel('146', referenceInfo.OrderInfo.Model)}
        {isPaint && this.renderLabel('179', referenceInfo.OrderInfo.Color)}
        {isPaint && this.renderLabel('289', renderFullDate(referenceInfo.OrderInfo.Pickup))}
        {isPaint && this.renderLabel('290', renderFullDate(referenceInfo.OrderInfo.Delivery))}
        {isPaint && isApproval && this.renderLabel('721', referenceInfo.TransportBefore, 'wrap')}
        {isPaint && isApproval && this.renderLabel('722', referenceInfo.TransportAfter, 'wrap')}

        {!isPaint && (
          <Panel title={translation('14827')}>
            <Inline fillChildNum={[0, 1]} block>
              <span>{referenceInfo.OriginalCompany.Name}:</span>
              <span>{renderFullDate(referenceInfo.OrderInfo.Pickup)}</span>
            </Inline>

            <PanelHeader text={translation('17880')} />
            <Inline fillChildNum={[0, 1]} block>
              <span>{referenceInfo.OriginalCompany.Name}:</span>
              <span>{renderFullDate(referenceInfo.OrderInfo.Delivery)}</span>
            </Inline>
          </Panel>
        )}
      </Panel>
    )
  }
}

ReferenceOrderData.propTypes = {
  referenceInfo: PropTypes.object.isRequired
}

export default ReferenceOrderData



// WEBPACK FOOTER //
// ./src/app/shared/modals/ReferenceOrderActionModal/ReferenceOrderData/index.js